<template>

<vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f w800">
    <div class="modal-header">
      <b>Detail studenta</b>
        <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>

    </div>

    <div class="modal__content" :key="kko">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Jméno</label>
            <input type="text" v-model="student.name" class="form-control" />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>příjmení</label>
            <input type="text" v-model="student.surname" class="form-control" />
          </div>
        </div>



      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="form-group">
            <label>e-mail</label>
            <input type="text" v-model="student.email" class="form-control" :readonly="!admin"/>
          </div>
        </div>


        <div class="col-md-6">
          <div class="form-group">
            <label>telefon</label>
            <input type="text" v-model="student.tel" class="form-control" />
          </div>
        </div>

      </div>
      <div class="row" v-if="student.id == undefined || student.id == null ">
        <div class="col-md-12 form-group">

          <label><input type="checkbox" v-model="student.change_password_helper"/>  Vynutit změnu hesla</label>
        </div>
        <div class="col-md-6 form-group">
          <label>Heslo</label>
          <input type="text" v-model="student.password_helper" class="form-control" />
        </div>
      </div>

      <!-- Firemní údaje -->
      <div class="row mt-4">
        <div class="col-md-12">
          <h6 class="mb-1">Firemní údaje</h6>
          <small class="text-muted">Tyto údaje se automaticky vyplní při objednávce</small>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Název firmy</label>
            <input type="text" v-model="student.company_name" class="form-control" placeholder="Volitelné"/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>IČO</label>
            <input type="text" v-model="student.business_id" class="form-control" placeholder="Volitelné"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>DIČ</label>
            <input type="text" v-model="student.vat_number" class="form-control" placeholder="Volitelné"/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>DIČ DPH</label>
            <input type="text" v-model="student.vat_number_dph" class="form-control" placeholder="Volitelné"/>
          </div>
        </div>
      </div>

    </div>
  <div class="modal__action">
    <button  class="btn btn-primary" @click="handleSaveChanges">uložit změny</button>
    <button class="btn btn-outline-dark ml-4" @click="showM=false">zrušit</button>
  </div>
</vue-final-modal>

</template>

<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import {VueFinalModal} from "vue-final-modal";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";
import moment from "moment/moment";
export default {
  name: "modal-ll-student"  ,
  components: { VueFinalModal },
  props:['student', 'admin'],
  mixins:[modalKkMixin],
  data(){
    return({
      maual_edit_datum:false,
        organizations:[],
      kko:21312
    })
  },
  mounted() {
    this.loadOrganizations()
  },
  watch:{
    student(){
      console.log('student', this.student)
      this.kko++
      this.maual_edit_datum = false
      if (this.student.memberships && this.student.memberships.length>0){
        this.student.organization_helper = this.student.memberships[0].organization_id
      }

      const cc_subs_until = moment(this.student.cc_subs_until ).unix() || 0
      const cc_until= moment(this.student.cc_until).unix() || 0
      if (cc_subs_until > cc_until) this.student.cc_until = this.student.cc_subs_until

    }
  },
  methods:{
    loadOrganizations(){
      axios.get('/conversation_club/organizations.json',{}).then(response =>{
        this.organizations = response.data.organizations
      })
    },
    handleSaveChanges(){
      if (this.student.id>0){

        axios.put(`/conversation_club/students/${this.student.id}`, { student: this.student }).then(response =>{
          //this.$toasted.show("Změny uloženy", {type: 'success'});
          toast('Změny uloženy', {type: 'success'});
          this.$emit('userUpdated')
          this.hideModal()
        })

      }else{
        this.createStudent()
      }
    },

    createStudent(){
      const formData = { student: this.student }
      axios.post('/conversation_club/students/create', formData).then(response =>{
        this.$emit('userUpdated')
        //this.$toasted.show("Změny uloženy", {type: 'success'});
        toast('Změny uloženy', {type: 'success'});
        this.hideModal()
      })
    }
  }
}
</script>

<style scoped>

</style>